export default __webpack_public_path__ + "static/media/furniture.a5c7761c.png";